/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GlobeIcon = /*#__PURE__*/ createSvgIcon(
  'GlobeIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM.5 8a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z" />
            <path d="M5.717 2.089C6.402.957 7.273.5 7.92.5c.35 0 .749.159 1.127.43.388.278.79.699 1.153 1.286.726 1.175 1.3 3.023 1.3 5.784 0 2.93-.573 4.784-1.309 5.924-.729 1.13-1.639 1.576-2.271 1.576-.643 0-1.513-.458-2.199-1.588C5.031 12.774 4.5 10.923 4.5 8s.528-4.773 1.217-5.911zm.856.517C6.012 3.533 5.5 5.183 5.5 8s.514 4.466 1.076 5.393c.567.935 1.157 1.107 1.344 1.107.198 0 .828-.184 1.431-1.119.597-.925 1.149-2.57 1.149-5.381 0-2.629-.546-4.281-1.15-5.258-.303-.49-.618-.808-.886-1-.278-.2-.475-.242-.544-.242-.193 0-.782.173-1.347 1.106z" />
            <path d="M8 10.55a9.5 9.5 0 00-5.662 1.52l.544.84a8.5 8.5 0 015.091-1.36h.054a8.5 8.5 0 015.09 1.36l.545-.84A9.5 9.5 0 008 10.55zM8 5.5a9.37 9.37 0 01-5.668-1.575l.556-.83A8.37 8.37 0 007.975 4.5L8 4.499l.026.002a8.5 8.5 0 005.09-1.36l.545.838A9.5 9.5 0 018 5.501zM15 8.5H1v-1h14v1z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM.5 10a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z" />
            <path d="M7.115 2.466C8.015 1.038 9.13.5 9.9.5c.412 0 .904.184 1.39.52.496.345 1.018.87 1.493 1.611C13.735 4.115 14.5 6.465 14.5 10c0 7.454-3.048 9.5-4.6 9.5-.773 0-1.89-.537-2.79-1.966C6.208 16.1 5.5 13.746 5.5 10s.71-6.1 1.615-7.534zm.845.533C7.19 4.22 6.5 6.366 6.5 10c0 3.634.688 5.78 1.457 7.001C8.729 18.227 9.563 18.5 9.9 18.5c.668 0 3.6-1.194 3.6-8.5 0-3.395-.735-5.545-1.558-6.829-.413-.643-.846-1.068-1.222-1.328-.387-.269-.682-.343-.82-.343-.331 0-1.165.272-1.94 1.5z" />
            <path d="M4.608 14.541C5.82 14.017 7.62 13.5 10 13.5c2.38 0 4.18.517 5.392 1.041a9.41 9.41 0 011.375.727 6.12 6.12 0 01.45.32l.027.023.008.006.003.003s.002.001-.325.38l-.326.379-.001-.001-.015-.012a5.098 5.098 0 00-.365-.26 8.411 8.411 0 00-1.228-.647c-1.1-.476-2.764-.959-4.995-.959-2.23 0-3.896.483-4.995.959-.55.238-.96.474-1.229.648a5.084 5.084 0 00-.364.26l-.015.011v.001L3.07 16a51.458 51.458 0 01-.326-.379l.001-.001.003-.003.008-.007.027-.021.094-.074c.082-.062.2-.147.356-.247.31-.201.769-.465 1.375-.727zM3.395 16.38l.001-.001zM2.744 4.379L3.07 4l.326-.379.001.001.015.012.068.053c.063.048.162.119.296.206.269.174.678.41 1.229.648 1.1.476 2.764.959 4.995.959 2.233 0 3.9-.472 5-.936.55-.232.96-.463 1.229-.632a5.061 5.061 0 00.364-.253l.015-.011v-.001l.322.383.321.383-.001.001-.003.003-.008.006a2.092 2.092 0 01-.121.093c-.082.06-.2.143-.356.241-.31.197-.769.453-1.374.709C14.176 5.996 12.378 6.5 10 6.5c-2.38 0-4.18-.517-5.392-1.041a9.408 9.408 0 01-1.375-.727 6.054 6.054 0 01-.477-.343l-.008-.006-.003-.003-.001-.001zM19 10.5H1v-1h18v1z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5zM.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12z" />
            <path d="M8.493 2.855C9.603 1.128 10.961.5 11.87.5c.481 0 1.073.211 1.669.615.606.411 1.249 1.043 1.835 1.939C16.55 4.847 17.5 7.698 17.5 12c0 9.085-3.816 11.5-5.63 11.5-.905 0-2.263-.628-3.373-2.355C7.383 19.413 6.5 16.558 6.5 12s.88-7.413 1.993-9.145zm.841.54C8.36 4.913 7.5 7.558 7.5 12s.862 7.087 1.838 8.605c.98 1.523 2.057 1.895 2.532 1.895.946 0 4.63-1.585 4.63-10.5 0-4.158-.92-6.807-1.962-8.399-.522-.796-1.075-1.329-1.56-1.658-.497-.337-.894-.443-1.108-.443-.48 0-1.557.372-2.536 1.895z" />
            <path d="M5.488 17.529C6.948 17.01 9.12 16.5 12 16.5c2.88 0 5.052.51 6.512 1.029.73.259 1.281.519 1.654.717a7.407 7.407 0 01.569.336l.01.007.002.002h.001s.001.001-.288.409l-.289.408-.002-.002-.019-.012a6.45 6.45 0 00-.454-.265 11.29 11.29 0 00-1.518-.658C16.818 17.99 14.76 17.5 12 17.5s-4.818.49-6.178.971c-.68.241-1.186.481-1.518.658a6.436 6.436 0 00-.454.265l-.019.012-.002.002L3.54 19l-.289-.408.002-.001.003-.002.01-.007a2.121 2.121 0 01.143-.093 7.4 7.4 0 01.425-.243c.373-.198.924-.458 1.654-.717zM3.251 5.408L3.54 5l.289-.408.002.002.019.012.086.055c.079.05.201.122.368.21.332.177.838.417 1.518.658C7.182 6.01 9.24 6.5 12 6.5c2.761 0 4.821-.477 6.182-.948.68-.235 1.187-.469 1.52-.641a6.498 6.498 0 00.453-.259l.018-.012.003-.001.284.411.284.412h-.002l-.003.003-.009.006a2.337 2.337 0 01-.143.09c-.098.06-.24.14-.426.238-.372.193-.923.446-1.653.699C17.048 7.002 14.878 7.5 12 7.5c-2.88 0-5.052-.51-6.512-1.029a12.268 12.268 0 01-1.654-.717 7.424 7.424 0 01-.569-.336l-.01-.007-.002-.002H3.25zM23 12.5H1v-1h22v1z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default GlobeIcon;
